import webdesign from '../images/slicing/service/webdesign.png'
import seo from '../images/slicing/service/seo.png'
import socialMedia from '../images/slicing/service/socialmedia.png'

export const firstPara = [
    "While the legacy platforms and applications provide business-critical functions, it is also evident that the legacy infrastructure inhibits the pace of innovation and speed to market.",
    "Enterprises must continuously modernize IT infrastructure and applications to keep up with customer, employee and stakeholder expectations.",
    "But the major challenges holding back innovation are navigating complexity and the integration required to maximize value from legacy infrastructure. Many of these legacy systems have been built on inflexible and closed architectures hindering cloud enablement & integration with digital native platforms.",
    "Enterprises that continuously optimize applications on the cloud, build connected applications ecosystem through intelligent automation and API hubs will come out as winners against their competition and ability to attract, retain customers.",
    "GTEN has experience of successfully executing many such platform and application modernizations and can help harness true potential of your IT infrastructure."
]

export const offeringsLegacy = [
    [{
        heading: 'Cloud Native',
        imageSrc: webdesign,
        readMore:'/cloudnative/',
        description: 'GTEN helps companies rapidly modernize applications, operations and remote infrastructure management, while establishing the governance and security needed in a multi-cloud world. We provide everything from front-end Cloud & Infrastructure Advisory Services, and Cloud Native Development to Migration Services and Intelligent Service Management.'
    },
    {
        heading: 'Application Architecture Services',
        imageSrc: seo,
        description: 'Our team works with our customer to facilitate and define right technology architecture for their applications. It may involve Business Rules Extraction, Application Lift & Shift, Monolithic applications to Micro-Services, API Based connectivity & Integration Services, SOA Enablement, User Interface and Experience redesign, Application Decommission and end of life management.'
    },
    {
        heading: 'Managed Services',
        imageSrc: socialMedia,
        description: 'GTEN delivers cloud, infrastructure and automation as managed services in a shared risk and reward model that focuses on delivery of target business outcomes which can be measured by key performance indicators(KPIs) that align to IT and business requirements for a best-in-class experience.'
    }],
]

export const legacyCoreValues = [
    [{
        heading: 'Improved operational efficiency & reduce costs',
        imageSrc: webdesign
    },
    {
        heading: 'Increased Agility, development Velocity',
        imageSrc: webdesign
    }],
    [{
        heading: 'Accelerated Innovation by tapping into Cloud native eco-system',
        imageSrc: webdesign
    },
    {
        heading: 'Increased competitive Advantage',
        imageSrc: webdesign
    }],
    [{
        heading: 'Faster speed to market with high performance applications',
        imageSrc: webdesign
    },
    {
        heading: 'Robust, Scalable & secure IT Infra to meet changing business needs',
        imageSrc: webdesign
    }]
]

export const firstParaCloudNative = [
    "“Cloud” is no longer the future, it’s the need of today, adoption of cloud calls for contemporary software architectures, containerized deployment, on-demand services and automation – and is arguably the most important component of digital journey for any organization.",
    "Adoption of cloud though sound simple but is dependent on numerous, complex choices to be made around providers and integration, making it difficult to even know where to start the journey.",
    "GTEN is a trusted partner to help guide in your journey. Our team will help to quickly create, launch and deliver your multi-cloud strategy, new services and products. We bring the best of all the major cloud providers into a seamless experience for your customers, employees and other stakeholders. We reduce complexity, costs and operational challenges while modernizing.",
]

export const offeringsCloudNative = [
    [{
        heading: 'Cloud Advisory Services ',
        description: 'Realize the full promise of cloud and grow faster with a multi-cloud strategy that considers your readiness and migration requirements as wellas a build and governance roadmap tailored to your organization’s situation.'
    },
    {
        heading: 'Cloud Migration & Modernization',
        description: 'Migrate rapidly with workload-specific strategies such as rehost, re-platform or modernize by refactoring applications through containerization to realize increased agility and business continuity at lower costs.'
    },
    {
        heading: 'Cloud Native Development',
        description: 'Develop new or re-imagine legacy applications with modern cloud-native architecture through multiple pathways such as serverless, microservices, container technology (Docker/Kubernetes) and CI/CD to deliver scalable, easy to maintain software services quickly'
    }],
    [{
        heading: 'DevOps Enablement',
        description: 'Deliver IT infrastructure agility and better software quality by bringing software development and IT ops together to improve observability, stability and repeatability through automation with infrastructure as code enabled by technologies like Terraform.'
    },
    {
        heading: 'Multi-Cloud Managed Services',
        description: 'Deliver world class service and performance with managed services designed for your infrastructure and business needs by continuously monitoring, managing and optimizing application operations and customer-focused service management.'
    }]
]

export const offeringsTestAutomation = [
    [{
        heading: 'Cloud Advisory Services ',
        description: 'Realize the full promise of cloud and grow faster with a multi-cloud strategy that considers your readiness and migration requirements as wellas a build and governance roadmap tailored to your organization’s situation.'
    },
    {
        heading: 'Cloud Migration & Modernization',
        description: 'Migrate rapidly with workload-specific strategies such as rehost, re-platform or modernize by refactoring applications through containerization to realize increased agility and business continuity at lower costs.'
    },
    {
        heading: 'Cloud Native Development',
        description: 'Develop new or re-imagine legacy applications with modern cloud-native architecture through multiple pathways such as serverless, microservices, container technology (Docker/Kubernetes) and CI/CD to deliver scalable, easy to maintain software services quickly'
    }],
    [{
        heading: 'DevOps Enablement',
        description: 'Deliver IT infrastructure agility and better software quality by bringing software development and IT ops together to improve observability, stability and repeatability through automation with infrastructure as code enabled by technologies like Terraform.'
    },
    {
        heading: 'Multi-Cloud Managed Services',
        description: 'Deliver world class service and performance with managed services designed for your infrastructure and business needs by continuously monitoring, managing and optimizing application operations and customer-focused service management.'
    }]
]